import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-user-dialog',
  templateUrl: './edit-user-dialog.component.html',
  styleUrls: ['./edit-user-dialog.component.scss']
})
export class EditUserDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EditUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditUserDialogData,
    private fb: FormBuilder
  ) { }

  formGroup: FormGroup;

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      'rpmAvatarURL': this.fb.control(this.data.rpmAvatarURL, [
        Validators.pattern(environment.rpmAvatarUrlRegExp)
      ])
    })
  }

  submit() {
    this.formGroup.markAsTouched();
    if (this.formGroup.invalid) return;
    this.dialogRef.close(this.formGroup.value.rpmAvatarURL)
  }

  cancel() {
    this.dialogRef.close();
  }

}

export interface EditUserDialogData {
  rpmAvatarURL: string
}
